import { AbstractControl, AbstractControlDirective } from '@angular/forms';

export type ControlType = AbstractControl | AbstractControlDirective | undefined | null;
